import {request} from '@/network/request'

export function fetchList(query) {
  return request({
    url: '/gaoligong/fieldData/page',
    method: 'get',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/gaoligong/fieldData',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/gaoligong/fieldData/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/gaoligong/fieldData/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/gaoligong/fieldData',
    method: 'put',
    data: obj
  })
}
